





















































import { Component, Vue } from 'vue-property-decorator';
import ReportContainer from '../../components/report-container/report-container.vue';
import FilterContainer from '../../components/filter-container/filter-container.vue';
import ReportPlaceHolder from '../../components/report-placeholder/report.placeholder.vue';
import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
import BigIconPanel from '@/modules/neodash/components/big-icon-panel/big-icon-panel.vue';
import ReportVueContainer from '../../components/report-vue-container/report-vue-container.vue';
import FilterDropDown from '../../components/filter-form/filter-drop-down/filterDropDown.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { IKeyValues } from '@/interfaces/key-value-interface';
import FormPeriod from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import FilterMultiSelect from '@/modules/neodash/components/filter-form/filter-multi-select/filterMultiSelect.vue';
import { ReportEnum } from '@/modules/neodash/model/types/enums/reportEnum';
import { i18nMixin } from '../../mixins';
import { NameValue, NameValues } from '@/modules/neodash/model/types/interfaces/NameValue';
import { MonthYear, Period } from '@/modules/neodash/model/types/interfaces/Period';
import { GET_PERIOD } from '@/modules/neodash/store/modules/reports/types';
import { Getter } from 'vuex-class';
import { FilterService } from '@/modules/neodash/services/filterService';
import { ServiceHelper } from '@/utils/service.helper';
import { CONFIG } from '@/config';
import moment from 'moment';
import {listAllSaleTypes} from '@/modules/neodash/model/constants/saleType';
import {ContextEnum} from '@/enums/context.enum';
import {traceLogAccess} from '@/services';
import { FilterPeriod } from '@/modules/neodash/model/types/interfaces/ThroughputFilters';

@Component({
  name: 'FordThroughput',
  components: {
    ReportVueContainer,
    ReportPlaceHolder,
    PageLoader,
    FilterDropDown,
    FilterContainer,
    ReportContainer,
    ReportAppBar,
    BigIconPanel,
    FormPeriod,
    FilterMultiSelect
  }
})
export default class FordThroughput extends Vue {
  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  public readonly translate = i18nMixin.methods.i18n;

  public readonly keyRegional: string = 'Filters.LocationType.Regionals';
  public readonly keyInfluenceArea: string = 'Filters.LocationType.InfluencedArea';
  public readonly keySegments: string = 'Common.Segment';
  public readonly keySalesType: string = 'Common.SaleType';
  public readonly keyLabelThroughput: string = 'Ford - Throughput';

  public reportGenerated: boolean = false;
  public isDownloading: boolean = false;
  public filters: IKeyValues = [];

  public regionals: NameValues = [];
  public influenceAreas: NameValues = [];
  public segments: NameValues = [];
  public limitValues: Period;
  public throughputPeriod: FilterPeriod[] = [];

  public readonly salesTypes: NameValues = listAllSaleTypes();

  public filtersModel: any = {
    chosenRegionals: null,
    chosenInfluenceAreas: null,
    chosenSegments: null,
    chosenPeriod: null,
    chosenSalesType: null
  };

  public created(): void {
    FilterService.getRegionalsFord()
      .then((regionals: NameValues) => {
        this.regionals = regionals;
      })
      .then(() => FilterService.getSegments())
      .then(segments => {
        this.segments = segments;
      })
      .then(() => FilterService.getThroughputFilters())
      .then(throughputFilters => this.throughputPeriod = throughputFilters.filterPeriod);
  }

  public getInfluenceAreas(): void {
    let ids = this.filtersModel.chosenRegionals.map((c: NameValue) => c.value);

    FilterService.getRegionalInfluenceAreasFord(ids).then((areas: NameValues) => {
      this.influenceAreas = areas;
    });
  }

  public get limits(): Period | null {
    if (this.throughputPeriod.length == 0) {
      return null;
    }

   const getMonthYear = (): MonthYear => {
      return {
        month: this.throughputPeriod[0].month,
        year: this.throughputPeriod[0].year
      }
    };

    return {
      initial: {
        year: this.throughputPeriod[this.throughputPeriod.length - 1].year,
        month: 1
      },
      final: getMonthYear()
    }
  }

  public get formValid(): boolean {
    const { filtersModel } = this;
    return (
      filtersModel.chosenRegionals &&
      filtersModel.chosenInfluenceAreas &&
      filtersModel.chosenPeriod &&
      filtersModel.chosenSalesType &&
      filtersModel.chosenSalesType.value !== 0 &&
      this.periodIsValid()
    );
  }

  public downloadReport() {
    const { filtersModel } = this;

    const params = {
      idRegional: filtersModel.chosenRegionals.map((c: NameValue) => c.value).join(),
      idInfluenceArea: filtersModel.chosenInfluenceAreas.map((c: NameValue) => c.value).join(),
      idSegments: filtersModel.chosenSegments.map(x => x.value),
      dtYearInit: filtersModel.chosenPeriod.value.dtYearInit,
      dtMonthInit: filtersModel.chosenPeriod.value.dtMonthInit,
      dtYearFinal: filtersModel.chosenPeriod.value.dtYearFinal,
      dtMonthFinal: filtersModel.chosenPeriod.value.dtMonthFinal,
      salesType: filtersModel.chosenSalesType.value
    };

    this.reportGenerated = true;
    this.isDownloading = true;

    const fileName =`Ford_Throughput_v${moment().format('YYYYMMDD')}.xlsx` ;

    traceLogAccess.logAction(ContextEnum.Report, 'Throughput (Ford) - Download', JSON.stringify(params));
    ServiceHelper.generateFile(`${CONFIG.URL.NEODASH_API}/api/neodash/getExcel/fordThroughput`, fileName, {
      method: 'post',
      parameters: params
    }).finally(() => {
      this.isDownloading = false;
    });
  }

 private periodIsValid(): boolean {
    const { filtersModel } = this;

    return (
      filtersModel.chosenPeriod.value.dtMonthFinal -
        filtersModel.chosenPeriod.value.dtMonthInit +
        12 * (filtersModel.chosenPeriod.value.dtYearFinal - filtersModel.chosenPeriod.value.dtYearInit) +
        1 <=
      12
    );
  }
}
